import { navLinks } from "@/data/main-data";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import Menu from "./Menu";
import PropertyButton from "./PropertyButton";
import { usePathname } from "next/navigation";

export default function Header({
  isHome,
  setShow,
}: {
  isHome: boolean;
  setShow: any;
}) {
  const t = useTranslations("Nav");

  const pathname = usePathname();
  const cleanPath = pathname?.replace("/en/", "").replace("/ar/", "") || "/";

  return (
    <header>
      <div
        className={`sm:container px-4 md:px-0 lg:w-[85%] mx-auto ${
          isHome ? "border-y border-white/20" : "border-b border-gray-300"
        }  py-2 flex justify-between items-center`}
      >
        <div className="logo">
          <Link href={"/"} onClick={() => setShow(false)}>
            <Image
              src={isHome ? "/logo.png" : "/custom-logo.png"}
              alt="Logo"
              width={110}
              height={50}
              priority
            />
          </Link>
        </div>
        <ul className="links hidden xl:flex items-center gap-4">
          {navLinks.map((link) => {
            const active = link?.href?.replace("/", "").replace("/", "");

            const isActive = cleanPath.includes(active);

            return (
              <li key={link.href}>
                <Link
                  href={link.href}
                  onClick={() => setShow(false)}
                  className={`${
                    isActive && link.href !== "/" ? "bg-main text-white" : ""
                  } ${
                    link.href === "/" && isHome ? "bg-main text-white" : ""
                  }  p-2 rounded-md hover:bg-main hover:text-white transition-colors duration-500 text-black ${
                    isHome && "text-white"
                  }`}
                >
                  {t(link.label)}
                </Link>
              </li>
            );
          })}
        </ul>
        <div className="flex items-center gap-4">
          <div className="hidden xm:block">
            <PropertyButton isHome={isHome} />
          </div>
          <Menu pathname={isHome} setShow={setShow} />
        </div>
      </div>
    </header>
  );
}
